import React, { useState } from "react";
import Chevron from "../../../assets/images/common/chevron-right.svg";
import OrderListTable from "../../../components/common/OrderListTable";
import "../../../assets/css/laboratory/bloodtest/orderedlist.scss";
import Searchbar from "../../../components/common/Searchbar";

const BloodTestOrderedList = () => {
  const [rows, setRows] = useState([
    {
      number: 1,
      name: "Sohaib",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      test: "Dettol handwash",
      total: "KWD 510.00",
      details: "show",
      status: "Approved",
    },
    {
      number: 2,
      name: "Sohaib",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      test: "Dettol handwash",
      total: "KWD 510.00",
      details: "show",
      status: "pending",
    },
    {
      number: 3,
      name: "Sohaib",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      test: "Dettol handwash",
      total: "KWD 510.00",
      details: "show",
      status: "Approved",
    },
    {
      number: 4,
      name: "Sohaib",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      test: "Dettol handwash",
      total: "KWD 510.00",
      details: "show",
      status: "Approved",
    },
    {
      number: 5,
      name: "Sohaib",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      test: "Dettol handwash",
      total: "KWD 510.00",
      details: "show",
      status: "Approved",
    },
    {
      number: 6,
      name: "Sohaib",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      test: "Dettol handwash",
      total: "KWD 510.00",
      details: "show",
      status: "Approved",
    },
    {
      number: 7,
      name: "Sohaib",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      test: "Dettol handwash",
      total: "KWD 510.00",
      details: "show",
      status: "Approved",
    },
    {
      number: 8,
      name: "Sohaib",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      test: "Dettol handwash",
      total: "KWD 510.00",
      details: "show",
      status: "Approved",
    },
    {
      number: 9,
      name: "Sohaib",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      test: "Dettol handwash",
      total: "KWD 510.00",
      details: "show",
      status: "Approved",
    },
    {
      number: 10,
      name: "Sohaib",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      test: "Dettol handwash",
      total: "KWD 510.00",
      details: "show",
      status: "Approved",
    },
    {
      number: 11,
      name: "Sohaib",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      test: "Dettol handwash",
      total: "KWD 510.00",
      details: "show",
      status: "Approved",
    },
  ]);
  const [searchQuery, setSearchQuery] = useState("");

  // Search Functionality
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <>
      <div className="row pl-3 pr-2 pt-4 orderedlist-tab">
        <div className="col-12">
          <p className="mb-0 orderedlist-heading">Ordered List</p>
        </div>

        <div className="col-12 my-4">
          <div className="row ">
            <div className="col-md-12">
              <p className="orderedlist-breadcrumb">
                <span>DASHBOARD</span>
                <img src={Chevron} />
                <span> LABORATORY</span>
                <img src={Chevron} />
                <span className="current-tab"> ORDERED LIST</span>
              </p>
            </div>
          </div>
          <div className="row m-0 p-0">
            <Searchbar onChange={handleSearchChange} value={searchQuery} />
          </div>
        </div>

        <div className="col-12 mb-5 pb-5">
          <OrderListTable rows={rows} searchQuery={searchQuery} />
        </div>
      </div>
    </>
  );
};

export default BloodTestOrderedList;
